'use client';

import { c as _c } from "react/compiler-runtime";
import { AccountPopover, type AccountPopoverVariant } from '../shared';
import { Details, Drawer, Links } from './components';
import './authenticated.scss';
type AuthenticatedProps = {
  variant: AccountPopoverVariant;
};
export function Authenticated(t0) {
  const $ = _c(3);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function renderContent(t2) {
      const {
        close
      } = t2;
      return <div className="account-authenticated"><Details onAction={close} /><Links onAction={close} /></div>;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const renderContent = t1;
  if (variant === "desktop") {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <AccountPopover accountHref="/account" variant="desktop">{renderContent}</AccountPopover>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Drawer>{renderContent}</Drawer>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}